/* eslint-disable react/prop-types */
import React, { useRef } from 'react';
import { Button } from '@bwoty-web/ui-kit';
import * as S from './Wrapper.style';

const Wrapper = ({
  children,
  numOfRenderedElems,
  numOfFilteredElems,
  numOfTotalElems,
  initialNumberOfVisibleElements,
  onExpand,
  onCollapse,
  moreLabel: initialMoreLabel,
  lessLabel: initialLessLabel,
}) => {
  const moreLabel = initialMoreLabel || 'Visa fler';
  const lessLabel = initialLessLabel || 'Visa färre';

  const isAtEndOfList = numOfRenderedElems === numOfTotalElems;
  const buttonIsVisible =
    numOfRenderedElems > 0 &&
    numOfTotalElems > initialNumberOfVisibleElements;
  const buttonIsDisabled = !isAtEndOfList && numOfFilteredElems === numOfRenderedElems

  const topScrollPlaceholder = useRef(null);
  const bottomScrollPlaceholder = useRef(null);

  const scrollIntoView = (position) => {
    setTimeout(() => {
      if (position === 'bottom') {
        bottomScrollPlaceholder.current.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
        });
        return;
      }
      const { top } = topScrollPlaceholder.current.getBoundingClientRect();
      const yOffset = -100;
      window.scrollTo({
        behavior: 'smooth',
        top: top + yOffset + window.scrollY,
      });
    }, 50);
  };

  const handleOnExpandOrCollapse = () => {
    if (isAtEndOfList) {
      onCollapse();
      scrollIntoView('top');
      return;
    }

    onExpand();
  };

  return (
    <>
      <div ref={topScrollPlaceholder} />
      <div>{children}</div>
      <div ref={bottomScrollPlaceholder} />
      {buttonIsVisible && (
        <S.ButtonWrapper>
          <Button
            variant="tertiary"
            type="button"
            onClick={handleOnExpandOrCollapse}
            size="m"
            disabled={buttonIsDisabled}
          >
            {isAtEndOfList ? lessLabel : moreLabel}
          </Button>
        </S.ButtonWrapper>
      )}
    </>
  );
};

export default Wrapper;
